<template>
  <div class="domain-promo">
    <div class="container">
      <h2>Now Offering 100's of Domain Extensions!</h2>
      Hundreds of new top-leve domains.  Buy 2, Get 10% off the Second.  Buy 3 or more, get 20% off of each over 2
      <div class="domain-cols">
        <div class="domain-availability-checker front-page-search">
          <brave-form>
            <md-field>
              <md-input class="domain-search" value="" placeholder="Type a domain name..." aria-label="input domain name"></md-input>
            </md-field>
            <md-button
                class="md-button md-accent md-raised"
                type="submit"
                @click="onSubmit">
              Search
            </md-button>
          </brave-form>
        </div>
        <div class="bn-domain-sales">
          <div class="domain-sale-items">
            <span class="dom-spin" v-if="loading"><md-progress-spinner :md-diameter="17" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner> getting sales..</span>
            <span v-for="sale in onsale">
                          .{{sale.tld}} <span class="price" v-if="sale.price"><span class="sales-price">${{sale.price_discounted}}</span> / <strike>${{sale.price}}</strike></span>
                      </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "domain-promo",
  props: [
    'image', // TODO: find out a way to dynamically import embeds
  ],
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/domain-promo.vue